var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white py-7 px-8" },
    [
      _c("SearchableDocumentsList", {
        attrs: {
          query: _vm.query,
          companyId: _vm.companyId,
          projectId: _vm.projectId,
          frozen: _vm.projectCompleted,
          currentUserRole: _vm.userRole,
          currentUser: _vm.currentUser,
          extraInfoHidden: "",
        },
        on: {
          listChanged: function ($event) {
            return _vm.$emit("documentsListChanged")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "secondaryData",
            fn: function ({ document }) {
              return [
                _c(
                  "CardInfoChip",
                  _vm._b(
                    {
                      attrs: {
                        message: _vm.getAccessScope(document),
                        showDecoration: false,
                      },
                    },
                    "CardInfoChip",
                    _vm._d({}, [_vm.getBadgeColor(document), true])
                  )
                ),
              ]
            },
          },
          {
            key: "optionalActions",
            fn: function ({
              documentId,
              fileName,
              documentExtension,
              uploadedByUserId,
              refetchDocuments,
            }) {
              return [
                _vm.accessScopeEditable(uploadedByUserId)
                  ? _c("ProjectDocumentAccessScope", {
                      staticClass: "flex justify-center w-full",
                      attrs: {
                        documentId: documentId,
                        fileName: fileName,
                        documentExtension: documentExtension,
                        projectId: _vm.projectId,
                        currentUserRole: _vm.userRole,
                      },
                      on: { accessScopeUpdated: refetchDocuments },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "emptyListActions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end pt-3 pb-5",
                  attrs: {
                    companyId: _vm.companyId,
                    projectId: _vm.projectId,
                    currentUserId: _vm.currentUser.id,
                    buttonSize: "xl",
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end",
                  attrs: {
                    companyId: _vm.companyId,
                    projectId: _vm.projectId,
                    currentUserId: _vm.currentUser.id,
                    currentUser: _vm.currentUser,
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }